import { render, staticRenderFns } from "./QuestionCategoryListItem.vue?vue&type=template&id=5a9b76cc&scoped=true"
import script from "./QuestionCategoryListItem.vue?vue&type=script&lang=js"
export * from "./QuestionCategoryListItem.vue?vue&type=script&lang=js"
import style0 from "./QuestionCategoryListItem.vue?vue&type=style&index=0&id=5a9b76cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9b76cc",
  null
  
)

export default component.exports